import { Component, Input } from '@angular/core';
import { FileDownloadDataServiceProvider } from '@services/files/file-download-service/file-download.data.service';
import { Contract } from '@models/models';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'save-contract-pdf',
	template: require('./save-contract-pdf.html')
})
export class SaveContractPdf {
	@Input() contract: Contract;
	isSpinnerActive: boolean;

	constructor(
		private fileDownloadDataService: FileDownloadDataServiceProvider,
		private messageService: MessageService
	) {}

	saveAsPdf(): void {
		this.isSpinnerActive = true;
		this.fileDownloadDataService
			.savePdfFile(this.contract.actions.SAVE_AS_PDF.url)
			.then((): boolean => (this.isSpinnerActive = false))
			.catch(({ error }): void => {
				const { errorTitle, errorMessage } = error;
				this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				this.isSpinnerActive = false;
			});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/jobs/modals/save-contract-pdf/save-contract-pdf.ts